import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { change as changeFieldValue, reduxForm } from 'redux-form';
import PassageiroAgendamentoViagem from './PassageiroAgendamentoViagem';
import cadastrarAgendamentoViagemPassageiros from '../../actions/agendamento-viagem/cadastrarAgendamentoViagemPassageiros';
import buscarMapaVeiculoAgendamentoViagemPoltrona from '../../actions/agendamento-viagem/buscarMapaVeiculoAgendamentoViagemPoltrona';
import { showSuccessMsg } from '../../util/messagesUtil';
import buscarPassageiroPorCpf from '../../actions/passageiro/buscarPassageiroPorCpf';
import $ from 'jquery';
import { realParaNumber } from '../../util/numberUtil';

export class ModalCadastrarPassageiroAgendamentoViagem extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.fecharModal = this.fecharModal.bind(this)
    }

    fecharModal() {
        $('#modalCadastrarPassageiroAgendamentoViagem')
            .modal('hide');
        $('#modalCadastrarPassageiroAgendamentoViagem')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.reset('formularioCadastrarPassageirosAgendamentoViagem');
    }

    removerPassageioModal(assento, fileira) {
        this.props.removerPassageiro(assento, fileira, this.props.andarSelecionado, this.fecharModal);
    }

    assentosSelecionados(andar) {
        let assentosSelicionado = []
        if (this.props.mapaVeiculoAgendamentoViagem.fileirasPrimeiroAndar && andar == 1) {
            assentosSelicionado = this.retornarAssentos(this.props.mapaVeiculoAgendamentoViagem.fileirasPrimeiroAndar);
        } else if (this.props.mapaVeiculoAgendamentoViagem.fileirasSegundoAndar && andar == 2) {
            assentosSelicionado = this.retornarAssentos(this.props.mapaVeiculoAgendamentoViagem.fileirasSegundoAndar);
        }

        return assentosSelicionado
    }

    retornarAssentos(fileiras) {
        let assentosSelicionado = [];
        fileiras.forEach(fileira => {
            fileira.assentos.forEach(assento => {
                if (assento.selecionado) {
                    assentosSelicionado.push(assento)
                }
            })
        });

        return assentosSelicionado;
    }

    montarParametros(values) {
        const passageiros = [...this.props.passageiros];
        const dadosPassageiros = passageiros.map(passageiro => {
            const formasPagamento = []
            
            if(passageiro.dinheiro) {
                formasPagamento.push({
                    tipo: 'Dinheiro',
                    base64Comprovante: '',
                    numeroComprovante: '',
                    valor: realParaNumber(values[`valorDinheiro${passageiro.poltronaId}`]),
                    quantidadeParcelas: 1,
                    nomeComprovanteVenda: ''
                });
            }

            if(passageiro.cartao) {
                formasPagamento.push({
                    tipo: 'Cartão',
                    base64Comprovante: '',
                    numeroComprovante: '',
                    valor: realParaNumber(values[`valorCartao${passageiro.poltronaId}`]),
                    quantidadeParcelas: Number(values[`quantidadeParcelas${passageiro.poltronaId}`]),
                    nomeComprovanteVenda: ''
                });
            }

            if(passageiro.pix) {
                formasPagamento.push({
                    tipo: 'PIX',
                    base64Comprovante: '',
                    numeroComprovante: '',
                    valor: realParaNumber(values[`valorPIX${passageiro.poltronaId}`]),
                    quantidadeParcelas: 1,
                    nomeComprovanteVenda: ''
                });
            }


            return Object.assign({}, passageiro, {
                cpf: values[`cpfPassageiro${passageiro.poltronaId}`] ? values[`cpfPassageiro${passageiro.poltronaId}`] : null,
                nome: values[`nomePassageiro${passageiro.poltronaId}`],
                rg: values[`rgPassegeiro${passageiro.poltronaId}`],
                telefone: values[`telefone${passageiro.poltronaId}`],
                dataNascimento: values[`dtNascimento${passageiro.poltronaId}`],
                valorPassageiro: values[`valorPassageiro${passageiro.poltronaId}`] ? values[`valorPassageiro${passageiro.poltronaId}`] : null,
                formasPagamento: formasPagamento
            });
        })

        return {
            agendamentoViagemId: this.props.agendamentoViagem.id,
            empresaId: this.props.empresaSelecionada.id,
            passageiros: dadosPassageiros
        };
    }

    submit(values) {
        const parametros = this.montarParametros(values);
        this.props.cadastrarAgendamentoViagemPassageiros(parametros)
            .then(() => {
                this.props.buscarMapaVeiculoAgendamentoViagemPoltrona(this.props.agendamentoViagem.id,
                    this.props.empresaSelecionada.id);
                this.props.limparPassageiros();
                showSuccessMsg('Os passageiros foram cadastrados');
                this.fecharModal();
            });
    }

    preencherValoresPassageiro(passageiro, poltronaId) {
        this.props.changeFieldValue('formularioCadastrarPassageirosAgendamentoViagem', `nomePassageiro${poltronaId}`, passageiro.nome);
        this.props.changeFieldValue('formularioCadastrarPassageirosAgendamentoViagem', `rgPassegeiro${poltronaId}`, passageiro.documentoComFoto ? passageiro.documentoComFoto.replace(/[^\d]+/g, '') : '');
        this.props.changeFieldValue('formularioCadastrarPassageirosAgendamentoViagem', `telefone${poltronaId}`, passageiro.telefone);
        this.props.changeFieldValue('formularioCadastrarPassageirosAgendamentoViagem', `dtNascimento${poltronaId}`, passageiro.dtNascimento);
    }

    handleCkeckCartao(poltronaId) {
        const passageiros = [...this.props.passageiros];
        const passageiroCorrente = passageiros.find(f => f.poltronaId === Number(poltronaId));
        if (passageiroCorrente.cartao) {
            passageiroCorrente.cartao = false;
        } else {
            passageiroCorrente.cartao = true;
        }

        this.props.atualizarPasageiro(passageiroCorrente);
    }

    handleCheckDinheiro(poltronaId) {
        const passageiros = [...this.props.passageiros];
        const passageiroCorrente = passageiros.find(f => f.poltronaId === Number(poltronaId));
        if (passageiroCorrente.dinheiro) {
            passageiroCorrente.dinheiro = false;
        } else {
            passageiroCorrente.dinheiro = true;

        }

        this.props.atualizarPasageiro(passageiroCorrente);
    }

    handleCheckPix(poltronaId) {
        const passageiros = [...this.props.passageiros];
        const passageiroCorrente = passageiros.find(f => f.poltronaId === Number(poltronaId));
        if (passageiroCorrente.pix) {
            passageiroCorrente.pix = false;
        } else {
            passageiroCorrente.pix = true;

        }

        this.props.atualizarPasageiro(passageiroCorrente);
    }

    formulario() {
        const {
            handleSubmit, submitting, invalid, pristine
        } = this.props;

        return (
            <>
                <form onSubmit={handleSubmit(this.submit)}>
                    {this.props.passageiros.filter(p => p.assento.poltrona.andar === this.props.andarSelecionado)
                        .sort((a, b) => a.numeroPoltrona - b.numeroPoltrona)
                        .map(it => <PassageiroAgendamentoViagem
                            key={`passageiro${it.poltronaId}Andar${this.props.andarSelecionado}`}
                            passageiro={it}
                            buscarPassageiroPorCpf={this.props.buscarPassageiroPorCpf}
                            preencherValoresPassageiro={this.preencherValoresPassageiro.bind(this)}
                            handleCkeckCartao={this.handleCkeckCartao.bind(this)}
                            handleCheckDinheiro={this.handleCheckDinheiro.bind(this)}
                            handleCheckPix={this.handleCheckPix.bind(this)}
                            removerPassageiro={this.removerPassageioModal.bind(this)}
                        />)}
                    <div className="modal-footer">
                        <button type="submit"
                            disabled={invalid || submitting || pristine ||
                                !this.props.passageiros.every(p => p.cartao || p.dinheiro || p.pix)}
                            className="btn btn-laranja">Salvar</button>
                    </div>
                </form>
            </>
        );
    }

    render() {
        return (
            <div className="modal fade show" id='modalCadastrarPassageiroAgendamentoViagem' role='dialog'
                aria-labelledby='modalCadastrarPassageiroAgendamentoViagem' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5>Adicionar Passageiros </h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <i className="material-icons">
                                    &#xe5cd;
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            {this.props.passageiros.filter(p => p.assento.poltrona.andar !== this.props.andarSelecionado).length > 0 && <>
                            <div className="alert alert-danger col-md-12">
                                <p>Você possui poltronas selecionadas em outro mapa. Desmarque-as antes de prosseguir.</p>
                            </div></>}
                            {this.formulario()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export function mapStateToProps(state) {
    return {
        empresaSelecionada: state.empresaSelecionada,
        mapaVeiculoAgendamentoViagem: state.mapaVeiculoAgendamentoViagem
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        cadastrarAgendamentoViagemPassageiros,
        buscarMapaVeiculoAgendamentoViagemPoltrona,
        buscarPassageiroPorCpf,
        changeFieldValue
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastrarPassageirosAgendamentoViagem',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(ModalCadastrarPassageiroAgendamentoViagem));